import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import {
  iconfaqsRoute,
  helpRoute,
  codeDefinitionsRoute,
  relNotesRoute,
  resourcesRoute,
  gettingStartedRoute,
} from '../../../config/navigation/routes';
import { isFeatureEnabled } from '../../../config/featureFlags';
import shouldShowContactInfo from '../../../utils/contactInfoHelper';

import './Support.scss';
import foundryImage from '../../../images/foundry1_min.jpg';

const Support = ({ auth, subscriptionLevel }) => {
  // Support page categories with reorganized items
  const supportItems = [
    {
      title: 'FAQs',
      description: 'Frequently asked questions about the ICON platform',
      route: iconfaqsRoute,
      icon: 'fa-question-circle',
    },
    {
      title: 'Help',
      description: 'General help documentation for using the ICON platform',
      route: helpRoute,
      icon: 'fa-info-circle',
    },
    {
      title: 'Code Definitions',
      description: 'Reference for codes and abbreviations used in the system',
      route: codeDefinitionsRoute,
      icon: 'fa-list-alt',
    },
    {
      title: 'Release Notes',
      description: 'Information about the latest features and updates',
      route: relNotesRoute,
      icon: 'fa-clipboard',
    },
    {
      title: 'Resources',
      description: 'Maximize the value of ICON for research and ultimately submit successful bids to government projects. Certain registrations and certifications must be achieved.',
      route: resourcesRoute,
      icon: 'fa-graduation-cap',
    },
    {
      title: 'Get started doing business with DOD',
      description: 'Doing business with the DOD will require certain registrations and certifications. Click for more details below',
      route: gettingStartedRoute,
      icon: 'fa-certificate',
    },
  ];

  console.log('Support Page: auth', auth);
  console.log('Support Page: subscriptionLevel', subscriptionLevel);

  const showContactInfo = shouldShowContactInfo(auth, subscriptionLevel, isFeatureEnabled('ENABLE_RESTRICTED_SUPPORT_INFO'));
  const isLoggedIn = !!(auth && (auth.jwtToken || auth.token));

  return (
    <Container fluid className="p-0">
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Support</title>
        <meta name="description" content="Access support resources for the ICON Portal" />
      </Helmet>

      {/* Hero Banner */}
      <div className="support-hero">
        <div className="support-hero-background" style={{ backgroundImage: `url(${foundryImage})` }} />
        <Container>
          <div className="support-hero-content">

            <h1>Support Resources</h1>
            <p className="lead">
              Find help and resources to get the most out of the ICON platform.
            </p>
          </div>
        </Container>
      </div>

      <Container className="nf-support-page">
        <Row className="support-cards-container">
          {supportItems.map((item) => (
            <Col md={6} lg={4} key={item.title} className="mb-4">
              <Card className="h-100 support-card">
                <CardBody>
                  <div className="icon-container">
                    <i className={`fa ${item.icon}`} />
                  </div>
                  <CardTitle tag="h3">{item.title}</CardTitle>
                  <p>{item.description}</p>
                  <Link
                    to={item.route}
                    className="support-button"
                  >
                    View {item.title}
                  </Link>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="support-additional-help mt-5 mb-4">
          <h2>Need More Help?</h2>
          <p>Our team is ready to assist you with any questions or issues you might encounter.</p>

          <div className="contact-info-container">
            <h3>For General Questions :</h3>

            <div className="contact-person">
              <p className="contact-name">ICON SUPPORT TEAM</p>
              <p className="contact-org">Non-Ferrous Founders&apos; Society</p>

              <div className="contact-details-wrapper" style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ position: 'relative' }}>
                  <div className={!showContactInfo ? 'blurred-contact-container' : ''}>
                    <div className="contact-details" style={{ paddingBottom: '0.5rem', marginBottom: 0 }}>
                      {isLoggedIn && <p><strong>Phone:</strong> <a href="tel:8472990876">(847) 299-0876</a></p>}
                    </div>
                  </div>
                  {isFeatureEnabled('ENABLE_BILLSBY') && !showContactInfo && (
                    <div className="upgrade-overlay">
                      <div className="upgrade-message">
                        {auth && auth.role === 'COMMON_USER' ? (
                          <p style={{ margin: 0, fontWeight: 'normal' }}>
                            Contact your Common Admin for your Organization. You will need to upgrade your subscription level to ICON PLUS or PRO to view Advanced Technical Support
                          </p>
                        ) : (
                          <React.Fragment>
                            In order for Advanced Technical Support
                            <span className="upgrade-highlight">Upgrade to ICON Plus or ICON Pro</span>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="contact-details" style={{ paddingTop: '0.5rem', marginTop: 0, position: 'relative', zIndex: 11, borderTop: !showContactInfo ? 'none' : '1px solid #eee' }}>
                  <p><strong>Email :</strong> <a href="mailto:support@iconportal.com?bcc=iconsupport@nffs.atlassian.net&subject=IT%20Support%20Request%20-%20ICON%20Portal&body=Please%20describe%20your%20request%20or%20issue%20below%3A%0A%0A">support@iconportal.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Container>
  );
};

Support.propTypes = {
  auth: PropTypes.object,
  subscriptionLevel: PropTypes.string,
};

Support.defaultProps = {
  auth: null,
  subscriptionLevel: '',
};

export default Support;



// WEBPACK FOOTER //
// ./src/pages/static/Support/Support.jsx